import { useEffect } from 'react'
import { FaFilter } from 'react-icons/fa'
import { VscClearAll } from 'react-icons/vsc'
import Button from '../../../../shared/components/Button/Button'

const EMPTY_OPTION = { value: "", label: "Sem filtro" }

const FILTER_OPTIONS = [
    EMPTY_OPTION,
    { value: "all", label: "Todos os vencimentos" },
    { value: "-all", label: "Perto do vencimento" },
    { value: "critical", label: "Vencimentos críticos" },
    { value: "radiator", label: "Radiador Sist. Arr." },
    { value: "injectionPump", label: "Bomba injetora" },
    { value: "tankCleaning", label: "Limpeza de tanque" },
    { value: "changeBattery", label: "Troca de bateria" },
    { value: "alternatorMegage", label: "Megagem de alternador" },
    { value: "equipmentSanitization", label: "Higienização de equipamento" },
    { value: "oilAndFilter", label: "Troca de óleo e filtro" },
]

function HorimetroFilterModal({ selectedFilter, onChange, onClear, onClose }) {

    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', onKey)
        return () => document.removeEventListener('keydown', onKey)
    }, [onClose])

    return (
        <div className="fm-overlay" onClick={onClose}>
            <div className="fm-box" onClick={(e) => e.stopPropagation()}>

                {/* ── Header ── */}
                <div className="fm-header">
                    <div className="fm-header-top">
                        <div className="fm-header-left">
                            <FaFilter size={24} className="fm-header-icon" />
                            <div>
                                <p className="fm-title">Filtrar vencimentos</p>
                                <span className="fm-accent" />
                            </div>
                        </div>
                        <button className="fm-close shd-modal-close" onClick={onClose}>X</button>
                    </div>
                    <div className="fm-header-actions">
                        <Button variant="cancel" icon={VscClearAll} onClick={onClear}>Limpar</Button>
                    </div>
                </div>

                {/* ── Body ── */}
                <div className="fm-body">
                    <div className="fm-section">
                        <span className="fm-label">Vencimento</span>
                        <div className="fm-status-row">
                            {FILTER_OPTIONS.map((opt) => (
                                <button
                                    key={opt.value}
                                    className={`fm-status-opt ${selectedFilter?.value === opt.value ? 'fm-status-opt-active' : ''}`}
                                    onClick={() => onChange(opt)}
                                >
                                    {opt.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default HorimetroFilterModal
export { FILTER_OPTIONS }
